export const api = {
  smsSend: "/auth/smsSend",
  login: "/auth/login",
  logout: "/auth/logout",
  getMeInfo: "/auth/me",

  industryList: "/industry/list",
  speechList: "/speech/list",
  speechDetail: "/speech/detail/",
  yearsList: "/speech/years",

  topicList: "/topic/list",
  itemsList: "/items/list",
  itemsPageload: "/items/pageload",
  itemsDetail: "/items/detail/",
  masterArea: "/master/area",
  policyTags: "/master/policyTags",
  companyType: "/master/companyType",
  concernArea: "/master/concernArea",
  matchList: "/policy/match",

  policyType: "/master/policyType",
  policyTopic: "/master/topic",
  publicYear: "/master/year",
  industryDirection: "/master/industry",
  policyList: "/policy/list",
  policyDetail: "/policy/detail/",

  databrainList1: "/databrain/list",
  databrainList2: "/databrain/list2",
  databrainList3: "/databrain/list3",
  databrainList4: "/databrain/list4",

  favorList: "/favor/list",
  favorDelete: "/favor/delete",
  favorAdd: "/favor/add",

  historyList: "/history/list",
  historyDelete: "/history/delete",

  imageCode: "/master/imageCode",
  consultAdd: "/consult/add",

  newDataList: "/master/new",
  complianceAreas: "/master/complianceAreas",
  industryMaster: "/master/industry",
};
